<template>
  <section
    ref='container'
    class="page-container">
    <h1>Enter Client Information</h1>


    <template v-if="!isReferralRequest">
      <div class="abs-top-right">
        <v-button @click="hanlerSave">Save Quote</v-button>
        <v-button @click="() => $router.back()">Previous</v-button>
        <v-button
          type="primary"
          @click="handlerNext">Next
        </v-button>
      </div>
    </template>
    <template v-else>
      <div class="abs-top-right">
        <v-button @click="$emit('back')">Previous</v-button>
        <v-button
          type="primary"
          @click="handlerNext">Next
        </v-button>
      </div>
    </template>


    <div class="flex">
      <section class="flex-1">
        <housemaid-policy-form
          v-if="productId == 12"
          ref="housemaid-policy-form"
          :form="formData"
          :check-refer="2"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <working-policy-form
          v-else-if="productId == 13"
          ref="working-policy-form"
          :check-refer="2"
          :form="formData"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <travel-policy-form
          v-else-if="productId == 14"
          ref="travel-policy-form"
          :check-refer="2"
          :isCheckDate="true"
          :form="formData"
          :isCancle="false"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <decoration-policy-form
          v-else-if="productId == 15"
          ref="decoration-policy-form"
          :form="formData"
          :check-refer="2"
          class="width-700"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <student-policy-form
          v-else-if="productId == 16"
          ref="student-policy-form"
          :form="formData"
          :check-refer="2"
          class="width-700"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <personal-policy-form
          v-else-if="productId == 18"
          ref="personal-policy-form"
          :form="formData"
          :check-refer="2"
          class="width-700"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <homefire-policy-form
          v-else-if="productId == 17"
          ref="homefire-policy-form"
          :form="formData"
          :check-refer="2"
          :formInitDataLock="formDataLock"
          class="width-700"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <fire-policy-form
          v-else-if="productId == 20"
          ref="fire-policy-form"
          :form="formData"
          :check-refer="2"
          class="width-700"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"/>
        <pet-policy-form
          v-else-if="productId == 22"
          ref="pet-policy-form"
          :form="formData"
          :check-refer="2"
          @changeCompute="changeCompute"
          @getFormData="getHousemaidFormData"></pet-policy-form>
        <template v-else>
          <lazy-dom>
            <el-form
              ref="form"
              :rules="rules"
              :model="formData">
              <div class="main-container flex-1">
                <!--                <el-tabs v-model="activeTab">-->
                <!--                  <el-tab-pane-->
                <!--                    v-for="(tab, index) in tabList"-->
                <!--                    :key="index"-->
                <!--                    :label="tab.label"-->
                <!--                    :name="tab.name"-->
                <!--                  ></el-tab-pane>-->
                <!--                </el-tabs>-->
                <!--                <h2>Policy Detail</h2>-->
                <div
                  class="detail-wrapper">
                  <div class="flex flex-align-center">
                    <div class="form-half form-item">
                      <span>Expected Effective Date</span>
                      <el-form-item prop="pcy_cmnt_dt">
                        <v-date-picker
                          v-model="formData.pcy_cmnt_dt"
                          :_45daysComfirm="true"
                          @change="handlerChangePcyDt"/>
                      </el-form-item>
                    </div>
                    <span class="mg-l-15 mg-r-15 color-dark fs-14">Or</span>
                    <v-checkbox
                      v-model="formData.is_eff_dt_delay"
                      :is-boolean="false"
                      button-type>As Soon As Possible</v-checkbox>
                  </div>
                  <template v-if="!isHzmb">
                    <div
                      v-if="formData.class_id == 14"
                      class="form-item form-half">
                      <span>Coverage</span>
                      <v-radio-group
                        v-model="formData.trm_of_cvr"
                        disabled
                        :button="true"
                        :list="allCoverTypeOptions"/>
                    </div>
                  </template>
                  <template v-if="formData.class_id !== 14">
                    <div class="flex-sb">
                      <div class="form-half">
                        <div
                          v-if="!isHzmb"
                          class="form-item">
                          <span>Coverage</span>
                          <el-form-item prop="trm_of_cvr">
                            <v-select
                              v-model="formData.trm_of_cvr"
                              :list="coverTypeOptions"/>
                          </el-form-item>
                        </div>
                        <div
                          v-if="formData.trm_of_cvr != 1||isHzmb"
                          class="form-item">
                          <span>Hire Purchase Owner</span>
                          <el-form-item prop="hp_ind">
                            <v-radio-group
                              v-model="formData.hp_ind"
                              :border="true"
                              :list="yesNoOptions"/>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-half">
                        <div
                          v-if="formData.trm_of_cvr != 1&&!isHzmb"
                          class="form-item">
                          <span>Vehicle Market Value (Sum Insured)</span>
                          <el-form-item prop="isrd_vl">
                            <v-input
                              v-model="formData.isrd_vl"
                              type="number"
                              :min="0"
                              append="HK$"/>
                          </el-form-item>
                        </div>
                        <div
                          v-if="(formData.trm_of_cvr != 1||isHzmb) && formData.hp_ind == 1"
                          class="form-item">
                          <span>Name of Hire Purchase Owner</span>
                          <el-form-item prop="mortgagor">
                            <v-select
                              v-model="formData.mortgagor"
                              :list="mortgagorOption"/>
                          </el-form-item>
                          <el-form-item
                            v-if="isMortgagorOther"
                            ref="mortgagor_other"
                            class="margin-top-ten"
                            prop="mortgagor_other">
                            <v-input
                              v-model="formData.mortgagor_other"
                            />
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div
                    v-if="benefitList.length>0"
                    class="info-box extra_checkbox">
                    <!--          <h2>Insured Items</h2>-->
                    <div
                      class="form-item form-half">
                      <span>Insured Items</span>
                      <el-form-item
                      >
                        <v-checkbox-group
                          v-model="formData.benefits"
                          :list="benefitList"
                          :isColumn="false"
                          @change="handlerExtra"
                        />
                      </el-form-item>
                    </div>
                  </div>
                  <div
                    v-if="formData.class_id == 11 && extrabenefitsList.length"
                    class="form-item form-half extra_checkbox">
                    <span>Extra Benefits</span>
                    <v-checkbox-group
                      v-model="formData.extra_benefits"
                      :isColumn="false"
                      :list="extrabenefitsList"
                      @change="handlerExtra"/>
                  </div>
                  <div class="info-box">
                    <h2>Policyholder Details</h2>
                    <template v-if="formData.class_id !== 14">
                      <span
                        v-if="formData.cust_typ === 1"
                        class="mg-b-10 label">The policyholder should be the owner of the insured vehicle.</span>
                      <span
                        v-else
                        class="mg-b-10 label">The policyholder should be the owner of the insured vehicle.
                        <br/>The information is filled according to the customer’s latest record.
                      </span>
                    </template>
                    <policy-holder
                      ref="policy-holder"
                      :formDataLock="formDataLock"
                      :form="formData"
                      :usage-ind="formData.usage_ind"
                      @one-driver="(status) => policyOneDriver = status"
                      @change-driver="handlerPolicyDriverInfo"
                      @getFormData="getSubFormData"
                      @confirm="handlerConfirmChangeInfo"/>
                  </div>

                  <div class="info-box">
                    <insured-vehicle-form
                      ref="insured-vehicle-form"
                      :formDataLock="formDataLock"
                      :form="formData"
                      :usageInd.sync="formData.usage_ind"
                      @get-data="getFieldData"
                      @getFormData="getSubFormData"
                      @handleModel="handleModel"
                      @handleInd="handleInd"
                      @already-owned="handleOwned"
                    />
                  </div>

                  <div class="info-box">
                    <h2>Named Driver Information</h2>
                    <drivers-base-info-form
                      ref="drivers-base-info-form"
                      :formDataLock="formDataLock"
                      :form="formData"
                      :usage-ind="formData.usage_ind"
                      :orderId="orderId"
                      :policyOneDriver="policyOneDriver"
                      @changeOpenStatus="changeDriversOpenStatus"
                      @getFormData="getSubFormData"
                      @upload-file="changeDriversFile"
                      @change-policy-file="handlerDriverPolicyFile"
                    />
                  </div>
                </div>
                <h2>Document</h2>
                <div
                  class="document-wrapper">
                  <div class="flex">
                    <div class="form-item">
                      <span v-if="formData.cust_typ == 1">PolicyHolder HKID</span>
                      <span v-else>Business Registration Certification</span>
                      <el-form-item>
                        <v-upload
                          :card="true"
                          :fileData="formData.id_type_pic"
                          :otherData="{
                            target: 'id_type_pic',
                            idKey: 'id_type_pic_path_id',
                            nameKey: 'id_type_pic_path'
                          }"
                          @uploadSuccess="handlerUploadSuccess"
                          @delete="handlerUploadDelete"
                        />
                      </el-form-item>
                    </div>
                    <div class="form-item">
                      <span>NCB proof (e.g. Renewal Notice)</span>
                      <el-form-item>
                        <v-upload
                          :card="true"
                          :fileData="formData.ncd_proof"
                          :otherData="{
                            target: 'ncd_proof',
                            idKey: 'ncd_proof_path_id',
                            nameKey: 'ncd_proof_path'
                          }"
                          @uploadSuccess="handlerUploadSuccess"
                          @delete="handlerUploadDelete"
                        />
                      </el-form-item>
                    </div>

                  </div>
                  <div class="flex">
                    <div
                      class="form-item">
                      <span>Vehicle Registration Document</span>
                      <el-form-item
                        ref="rgtn_pic_path_id"
                        prop="rgtn_pic_path_id"
                      >
                        <v-upload
                          :card="true"
                          :fileData="formData.rgtn_pic"
                          :otherData="{
                            target: 'rgtn_pic',
                            idKey: 'rgtn_pic_path_id',
                            nameKey: 'rgtn_pic_path'
                          }"
                          @uploadSuccess="handlerUploadSuccess"
                          @delete="handlerUploadDelete"
                        />
                      </el-form-item>
                    </div>
                    <div
                      class="form-item">
                      <span>Vehicle Registration Document with previous owner name / Vehicle Document</span>
                      <el-form-item
                        ref="rgtn_with_owner_pic_path_id"
                        prop="rgtn_with_owner_pic_path_id"
                      >
                        <v-upload
                          :card="true"
                          :fileData="formData.rgtn_with_owner_pic"
                          :otherData="{
                            target: 'rgtn_with_owner_pic',
                            idKey: 'rgtn_with_owner_pic_path_id',
                            nameKey: 'rgtn_with_owner_pic_path'
                          }"
                          @uploadSuccess="handlerUploadSuccess"
                          @delete="handlerUploadDelete"
                        />
                      </el-form-item>
                    </div>
                  </div>
                  <!--                  <div-->
                  <!--                    v-if="formData.cust_typ == 2"-->
                  <!--                    class="flex">-->
                  <!--                    <div-->
                  <!--                      class="form-item">-->
                  <!--                      <span>Business Registration Certificate</span>-->
                  <!--                      <el-form-item-->
                  <!--                        ref="br_pic_path_id"-->
                  <!--                        prop="br_pic_path_id">-->
                  <!--                        <v-upload-->
                  <!--                          :card="true"-->
                  <!--                          :fileData="formData.br_pic"-->
                  <!--                          :otherData="{-->
                  <!--                            target: 'br_pic',-->
                  <!--                            idKey: 'br_pic_path_id',-->
                  <!--                            nameKey: 'br_pic_path'-->
                  <!--                          }"-->
                  <!--                          @uploadSuccess="handlerUploadSuccess"-->
                  <!--                          @delete="handlerUploadDelete"-->
                  <!--                        />-->
                  <!--                      </el-form-item>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <h2>Named Driver Information</h2>
                  <div class="drivers-file-container">
                    <div
                      v-for="(item, index) in nm_drvr_list_file"
                      v-show="isHzmb&&index>0? false: true"
                      :key="index"
                      class="card">
                      <span class="title">Driver {{ index + 1 }}</span>
                      <div
                        v-show="!item.open"
                        class="mask"></div>
                      <div class="form-item">
                        <span>HKID Card File</span>
                        <file-container
                          :edit="true"
                          titleName= "HKID Card File"
                          :fileData="{
                            url: item.nm_drvr_id_type_pic_url,
                            client_name: item.nm_drvr_id_type_pic_client_name,

                          }"
                          :otherData="{
                            index,
                            type: 'driver',
                            idKey: 'nm_drvr_id_type_pic_path_id',
                            nameKey: 'nm_drvr_id_type_pic_path',
                            urlKey: 'nm_drvr_id_type_pic_url',
                            client_name:'nm_drvr_id_type_pic_client_name',

                          }"
                          @delete="handlerDeleteFile"
                          @uploadSuccess="handlerUploadSuccess"/>
                        <!-- <v-upload
                      :otherData="{
                        index,
                        idKey: 'nm_drvr_id_type_pic_path_id',
                        nameKey: 'nm_drvr_id_type_pic_path'
                      }"
                      @uploadSuccess="handlerUploadSuccess"
                    /> -->
                      </div>
                      <div class="form-item">
                        <span>{{isHzmb?"Mainland Driver's License File":'Driving Licence File'}}</span>
                        <file-container
                          :edit="true"
                          :fileData="{
                            url: item.nm_drvr_licence_pic_url,
                            client_name: item.nm_drvr_licence_client_name
                          }"
                          :otherData="{
                            index,
                            type: 'driverLicence',
                            idKey: 'nm_drvr_licence_pic_path_id',
                            nameKey: 'nm_drvr_licence_pic_path',
                            urlKey: 'nm_drvr_licence_pic_url',
                            client_name:'nm_drvr_licence_client_name'
                          }"
                          titleName= "Driving Licence File"
                          @delete="handlerDeleteFile"
                          @uploadSuccess="handlerUploadSuccess"/>
                        <!-- <v-upload
                      :otherData="{
                        index,
                        idKey: 'nm_drvr_licence_pic_path_id',
                        nameKey: 'nm_drvr_licence_pic_path'
                      }"
                      @uploadSuccess="handlerUploadSuccess"
                    /> -->
                      </div>
                    </div>
                  </div>
                  <h2>Additional Documents</h2>
                  <file-container
                    v-for="(item, index) in formData.other_file"
                    :key="index"
                    :fileData="item"
                    :otherData="{
                      index,
                      type: 'other'
                    }"
                    :edit="true"
                    titleName= "Additional Documents"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                  <v-upload
                    :otherData="{
                      type: 'other',
                    }"
                    @uploadSuccess="handlerUploadSuccess"/>
                </div>
              </div>
            </el-form>
            <confirm-information
              ref="confirm-information"
              :upd_def_info="formData.updDefInfo"
              @confirm="handlerConfirmChangeInfo"/>
          </lazy-dom>
        </template>

        <lazy-dom notLoading>
          <use-personal-data
            ref="use-personal-data"
            @sendData="getData"></use-personal-data>
        </lazy-dom>

      </section>
      <div class="right">
        <div class="plan-info-container">
          <div class="flex flex-algin">
            <span class="icon icon-content">
              <img
                :src="plan_info.company_icon"
                alt="company"/>
            </span>
            <span
              class="icon icon-content"
            >
              <font-awesome-icon
                v-if="formData.class_id"
                :icon="getOptionName('iconOptions', formData.class_id)" />
            </span>
            <span class="label">{{ formData.plan }}</span>
          </div>
          <template v-if="extraBenefitSelect.length>0&&formData.class_id==11">
            <div
              v-for="(item,index) in extraBenefitSelect"
              :key="index"
              class="flex flex-algin">
              <span
                class="icon icon-content"
              >
                <img
                  :src="getOptionData('companySmallIcon', item.content.company_id).logo? getOptionData('companySmallIcon', item.content.company_id).logo: item.content.company_logo"
                >
              </span>
              <span
                class="icon"
              >
                <font-awesome-icon
                  icon="plus-square" />
              </span>
              <span class="label">{{ item.name }}</span>
            </div>
          </template>
          <!-- <span
            class="label"
          >{{ getOptionName('classOptions', formData.class_id) }} Insurance {{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }} Plan</span> -->
          <v-button
            type="info"
            @click="planClick">Plan Info
          </v-button>
          <plan-quote-info
            :amount="amount"
            :formData="quote_coverage_list">
            <template>
              <div
                v-if="referrer_is_special"
                class="flex-info">
                <span>Referrer Discount</span>
                <span>
                  <v-input
                    v-model.number="code_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    key-non-chinese
                    :max="max_code_disc_prm"
                    :min="0"
                    @blur="handlerApplyCode"></v-input>
                </span>
              </div>
            </template>
          </plan-quote-info>

          <!--          <div class="form-item">-->
          <!--            <span>Promo Code</span>-->
          <!--            <v-input v-model="code" />-->
          <!--          </div>-->
          <code-select
            :customerId="customerId"
            :orderId="orderId"
            :notApply="true"
            :isQuote="false"
            :isSpon="isSpon"
            :is-user="true"
            :is-fina="isFina"
            :isGuest="formData.is_share_guest_order == 1"
            :customer="formData.customer"
            @check-code="handlerApplyCode"
          ></code-select>

        </div>
      </div>
    </div>

    <plan-dialog
      ref="plan-dialog"
      :planInfo="quote_coverage_list"/>

    <div
      v-if="isDev"
      class="text-block">
      <v-button
        type="danger"
        @click="handlerTest">測試數據
      </v-button>
    </div>
    <to-top :el='container'></to-top>
    <message-dialog
      ref='msg'
      @clearOptions='clearExtraOptions'></message-dialog>
  </section>
</template>
<script>
import InsuredVehicleForm from '@/views/components/insured-vehicle-form'
import PolicyHolder from '@/views/components/policy-holder-form'
import DriversBaseInfoForm from '@/views/components/drivers-base-info-form'
import PlanDialog from './dialogs/plan-dialog'
import FileContainer from '@/views/components/file-container'
import CodeSelect from '@/views/components/code-select'
import {
  getQuoteDetail
} from '@/api/quote'
import {applyOrderCode, getExtraCompute, saveOrder, verifyPromoCode} from '@/api/order'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
// import MixinAllOptions from '@/mixins/all-options'
import {mapActions, mapState} from 'vuex'
import HousemaidPolicyForm from './modules/housemaid/form/housemaid-policy-form'
import WorkingPolicyForm from './modules/working/form/working-policy-form'
import TravelPolicyForm from './modules/travel/form/travel-policy-form'
import StudentPolicyForm from './modules/student/form/student-policy-form'
import PersonalPolicyForm from './modules/personal/form/personal-policy-form'
import DecorationPolicyForm from './modules/decoration/form/decoration-policy-form'
import HomefirePolicyForm from './modules/homefire/form/homefire-policy-form'
import firePolicyForm from './modules/homefire/form/fire-policy-form'
import PlanQuoteInfo from '@/views/components/plan-quote-info'
import ConfirmInformation from '@/views/components/dialogs/confirm-information'
import MessageDialog from '@/components/message_box'
import UsePersonalData from '@/views/components/use-personal-data'
import {getAccountDetail} from '@/api/account'
import MixinReferralOption from '@/mixins/referral-option'
import PetPolicyForm from '@/views/quoting/modules/pet/form/pet-policy-form'
import dayjs from 'dayjs'

export default {
  name: 'ClientInfomation',
  components: {
    PetPolicyForm,
    InsuredVehicleForm,
    PolicyHolder,
    DriversBaseInfoForm,
    PlanDialog,
    FileContainer,
    HousemaidPolicyForm,
    WorkingPolicyForm,
    TravelPolicyForm,
    StudentPolicyForm,
    DecorationPolicyForm,
    HomefirePolicyForm,
    PersonalPolicyForm,
    firePolicyForm,
    PlanQuoteInfo,
    ConfirmInformation,
    CodeSelect,
    MessageDialog,
    UsePersonalData
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinReferralOption],
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    referralRequestId: {
      type: Number,
      default: 0
    },
    requestOrderId: {
      type: Number,
      default: 0
    },
    requestQuoId: {
      type: Number,
      default: 0
    },
  },
  data() {
    const fileObj = {
      thumb_url: '',
      url: '',
      client_name: '',
      path: '',
      id: ''
    }
    const driversFileObj = {
      open: false,
      nm_drvr_id_type_pic_path: '',
      nm_drvr_id_type_pic_path_id: '',
      nm_drvr_id_type_pic_url: '',
      nm_drvr_licence_pic_path: '',
      nm_drvr_licence_pic_path_id: '',
      nm_drvr_licence_pic_url: '',
      nm_drvr_id_type_pic_client_name: '',
      nm_drvr_licence_client_name: '',

    }
    const checkNcdProof = (rule, value, callback) => {
      const {ncd_pct} = this.formData
      if (!value && ncd_pct != 0) {
        callback(new Error(this.$t('placeholder.upload')))
      }
      callback()
    }
    return {
      fileObj,
      driversFileObj,
      code_disc_prm:'',
      saveEdit: false,
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      policyOneDriver: false, // 投保人關聯第一名記名司機
      quote_coverage_list: {},
      amount: '',
      isSelf: '',
      formData: {
        updDefInfo: [],
        extra_benefits: [],
        class_id: '',
        less_verify_save: 0, // 是否僅保存部分資料（1：部分保存；0：全部保存   --标记是create 还是 edit
        pcy_cmnt_dt: '',
        mortgagor: '',
        trm_of_cvr: 1,
        hp_ind: '',
        isrd_vl: '',
        already_owned_by_ind: '',
        rgtn_no: '',
        usage_ind: '',
        brand_id: '',
        rgtn_mdl: '',
        typ_of_bdy_id: '',
        rgtn_yr: '',
        engn_cpcty: '',
        no_of_seats: '',
        chasis_no: '',
        engn_no: '',
        car_modified_ind: '',
        car_camcorder_ind: '',
        business_purposes: [],
        ncd_pct: '',
        prev_insurer_nm: '',
        prev_rgtn_no: '',
        prev_pcy_no: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_title: '',
        isrd_dob: '',
        id_type: '',
        id_no: '',
        mobile_no: '',
        email: '',
        occ_id: '',
        isrd_com_nm: '',
        phone_no: '',
        bsns_nature_id: '',
        contact_nm: '',
        contact_occ_id: '',
        contact_phone: '',
        contact_mobile: '',
        hldr_is_drvr_ind: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        cust_typ: '',
        nm_drvr_list: [],
        // 11
        model_id: '',
        tonnage: '',
        code_disc_prm: '',
        code_disc_pct: '',
        // file
        id_type_pic: {},
        id_type_pic_path_id: '',
        id_type_pic_path: '',
        rgtn_pic: {},
        rgtn_pic_path_id: '',
        rgtn_pic_path: '',
        rgtn_with_owner_pic: {},
        rgtn_with_owner_pic_path_id: '',
        rgtn_with_owner_pic_path: '',
        ncd_proof: {},
        ncd_proof_path_id: '',
        ncd_proof_path: '',
        br_pic: '',
        br_pic_path: '',
        br_pic_path_id: '',
        other_file: [],
        quote_coverage_list: {},
        mortgagor_other:'',
        is_eff_dt_delay:'',
        benefits:[]
      },
      resultFormData: {},
      documentForm: {
        other_file: []
      },
      referrer_is_special:false,
      max_code_disc_prm:0,
      code: '',
      activeTab: 'detail',
      planDialog: false,
      tabList: [
        {
          label: 'Policy Detail',
          name: 'detail'
        },
        {
          label: 'Document',
          name: 'document'
        }
      ],
      subForm: {
        'insured-vehicle-form': false,
        'policy-holder': false,
        'drivers-base-info-form': false
      },
      nm_drvr_list_file: [
        {
          ...driversFileObj
        },
        {
          ...driversFileObj
        },
        {
          ...driversFileObj
        },
        {
          ...driversFileObj
        }
      ],
      extraRules: {
        ncd_proof_path_id: [
          {validator: checkNcdProof, trigger: ['change', 'blur']}
        ]
      },
      container:null,
      personalData: {},
      pre_fill_referrer_code: ''
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('account', ['customerId']),
    ...mapState('coupon', ['selectCode']),
    ...mapState('errorfield', ['errorField']),
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id==15
    },
    cust_typ(){
      let {cust_typ} = this.$route.query
      return Number(cust_typ)
    },
    isFina(){
      //1：HC，2：Fina
      let {merchant_platform } = this.form||{}
      return merchant_platform==2
    },
    form(){
      return this.formData||{}
    },
    extraBenefitSelect(){
      let {extra_benefits=[]} = this.formData
      let extraOption = this.allOptions11.extra_benefits||[]
      let arr = extra_benefits.reduce((result,item)=>{
        extraOption.some(option=>{
          if(option.id == item){
            result.push(option)
          }
        })
        return result
      },[])
      if(this.isFina)return []
      return arr||[]
    },
    orderId() {
      if (this.isReferralRequest) {
        return this.requestOrderId
      }
      return this.$route.query.order_id
    },
    quoId() {
      if (this.isReferralRequest) {
        return this.requestQuoId
      }
      return this.$route.query.quo_id
    },
    localAllOptions() {
      const classId = this.formData.class_id
      if (classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${classId}`] || {mortgagor: []}
      }
    },
    isSpon() {
      let {plan_info = {}} = this.quote_coverage_list
      let {is_sponsor = ''} = plan_info
      return is_sponsor == 1
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.formData||{}
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    benefitList(){
      let {quote_coverage_list} =this.formData||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      kyc_benefit.some(item=>{
        // if(item.is_selected==1)
        //   this.formData.benefits.push(item.id)
        if(item.is_show!==0){
          arr.push({name:item.name,id:item.id})
        }
      })
      return arr||[]
    },
    plan_info(){
      let {quote_coverage_list} =this.formData||{}
      let {plan_info={}} = quote_coverage_list||{}
      return plan_info||{}
    },
    extrabenefitsList() {
      const classId = this.formData.class_id
      let benefits = this.localAllOptions.extra_benefits || []
      let list = benefits.filter(item=>item.is_enabled==1)
      if(classId==11){
        list = benefits.filter((item) => item.is_kyc_enable == 1||item.is_enabled==1)
      }
      if(this.isFina) return []
      return list||[]
    },
    isCopy(){
      let {copy} = this.$route.query||{}
      return copy == 1
    }
  },
  watch:{
    'formData.benefits': {
      deep: true,
      handler(val = [], old) {
        if([11, 12].includes(Number(this.formData.class_id))) {
          const arr = this.formData.class_id == 11?
            [256, 512]:
            [4, 8, 16]
          // 新增才需要考慮
          if(val.length > old.length) {
            // 判斷有多少個是衝突的
            const filterList = val.filter(item => arr.includes(item))
            if(filterList.length > 1) {
              let flag = false
              const result = val.reduce((result, item) => {
                if(arr.includes(item) && !flag) {
                  flag = true
                  return result
                }
                result.push(item)
                return result
              }, [])
              this.formData.benefits = JSON.parse(JSON.stringify(result))
            }
          }
        }
      }
    },
    orderId:{
      immediate:true,
      async handler(val){
        if(val){
          await this.network().getQuoteDetail()
        }
      }
    }
  },
  async  created() {

  },
  async mounted(){
    // 這裏判斷什麽產品的數據
    await  this.network().getAccountDetail()
    this.$nextTick(()=>{
      this.getElement()
    })
  },
  methods: {
    ...mapActions('quote', ['setQuoteInformationForm','setQuoteForm']),
    ...mapActions('coupon', ['setCouponData', 'setSelectCode','setReferrerData']),
    ...mapActions('errorfield', ['setErrorData']),
    ...mapActions('account', ['setCustomerId']),
    handleInitRefer(){
      this.initReferrerId()
      this.network().applyOrderCode()
    },
    handlerChangePcyDt(){
      this.formData.is_eff_dt_delay = 0
      this.handlerExtra()
    },
    handlerExtraData(){
      let {class_id,model_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr,trm_of_cvr = []} = this.formData||{}
      if(class_id==11)
      {
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,rgtn_yr,enough_age_ind,enough_exp_ind})
      }
    },
    handleModel(model_id){
      let {class_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr,trm_of_cvr = []} = this.formData||{}
      if(class_id==11)
      {
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,rgtn_yr,enough_age_ind,enough_exp_ind})
      }
    },
    handleInd(params){
      Object.assign(this.formData,params)
      let obj = JSON.parse(JSON.stringify(this.formData))
      this.formData = obj
    },
    handleOwned(params){
      this.formData.already_owned_by_ind = params
    },
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        order_id:this.orderId,
        pcy_cmnt_dt,
        benefits
      }
      this.network().getExtraCompute(params)
    },
    changeCompute(data){
      let params = {
        ...data,
        order_id:this.orderId,
      }
      this.network().getExtraCompute(params)
    },
    planClick() {
      this.$refs['plan-dialog'].changeDialog()
    },
    handlerSetCode(data, type) {
      // 如果存在type就是手动输入的referrer code
      // 如果是自动填入的要先判断是否存在pre_fill_referrer_code，如果有则用预填的pre_fill_referrer_code
      let {customer_id} = data||{}
      this.setCustomerId(customer_id)
      if(!type && this.pre_fill_referrer_code){
        return
      }
      let {coupon, code, coupon_code, quote_coverage_list, referrer, referrer_user_id,campaign_code} = data
      let params = {}
      if (coupon_code) {
        params.coupon = {...coupon}
      }
      if (code||this.isFina&&referrer.code) {
        params.code = {code:this.isFina?referrer.code:code, referrer, referrer_user_id}
      }
      if(campaign_code)
      {
        params.coupon= {coupon_code:campaign_code,title:campaign_code}
        params.is_campaign_code = 1
      }
      this.setSelectCode(params)

    },
    handlerGetAllQuote() {

    },
    getFieldData({key, value}) {
      this.$set(this.formData, key, value)
    },
    handlerApplyCode() {
      // if (!this.code) {
      //   this.$message({
      //     type: 'warning',
      //     message: '請輸入優惠碼'
      //   })
      //   return
      // }
      this.network().verifyPromoCode()

    },
    // 投保人資料關聯幾名司機
    handlerPolicyDriverInfo(data) {
      const result = {
        ...data,
        id_type_pic: this.formData.id_type_pic
      }
      this.$refs['drivers-base-info-form'].handlerPolicyDriverInfo(result)
      const {
        id_type_pic, hldr_is_drvr_ind
      } = result
      const {id, client_name, path, url} = id_type_pic || {}
      if (hldr_is_drvr_ind == 1) {
        Object.assign(this.nm_drvr_list_file[0], {
          nm_drvr_id_type_pic_path_id: id,
          nm_drvr_id_type_pic_path: path,
          nm_drvr_id_type_pic_url: url,
          nm_drvr_id_type_pic_client_name: client_name
        })
      }
    },
    handlerTest() {
      if (this.productId == 12) {
        this.formData = Object.assign(
          this.formData,
          {
            pcy_cmnt_dt: '2020-10-20',
            period_of_cvr: 1,
            isrd_title: 1,
            isrd_lst_nm: 'a',
            isrd_fst_nm: 'peng',
            id_type: 1,
            id_no: 'X3575239',
            occ_id: 5,
            mobile_no: '67896789',
            email: '55@qq.com',
            is_addr_same_ind: false,
            domestic_title: 1,
            full_name: 'apeng',
            domestic_id_type: 1,
            domestic_id_no: 'X3575239',
            duty_id: 1,
            domestic_dob: '1990-05-04',
            nationality_id: 1,
            monthly_salary: '5500',
            addr_room: 'AA',
            addr_floor: '15',
            addr_block: 'BB',
            addr_building: 'CC',
            addr_street: 'DD',
            addr_district: 5,
            addr_area: 2,
            addr_region: 1,
          }
        )
        return
      }

      const testData = {
        pcy_cmnt_dt: '2020-10-24',
        mortgagor: 1,
        hp_ind: 1,
        less_verify_save: 0,
        isrd_vl: 5000,
        isrd_lst_nm: 'A',
        isrd_fst_nm: 'Peng',
        isrd_title: 1,
        isrd_dob: '1990-01-01',
        id_type: 1,
        // id_no: 'A1234563',
        mobile_no: '8888888',
        email: 'example@next.com',
        occ_id: 11,
        isrd_com_nm: 'NIT',
        phone_no: '133333333',
        bsns_nature_id: 12,
        contact_nm: 'APeng',
        contact_occ_id: 2,
        // contact_email: '',
        addr_room: 'AA',
        addr_floor: '15',
        addr_block: 'BB',
        addr_building: 'CC',
        addr_street: 'DD',
        addr_district: 5,
        addr_area: 2,
        addr_region: 1,
        rgtn_no: '55555',
        // class_id: 14,
        usage_ind: 1,
        brand_id: 125,
        rgtn_mdl: '5555',
        typ_of_bdy_id: 20,
        rgtn_yr: 2015,
        engn_cpcty: 200,
        ncd_pct: '0',
        no_of_seats: 3,
        chasis_no: '5555',
        engn_no: '5555',
        // trm_of_cvr: 1,
        car_modified_ind: 1,
        car_camcorder_ind: 0,
        business_purposes: [],
        prev_rgtn_no: '5555',
        prev_pcy_no: '66666',
        prev_insurer_nm: 1,
        contact_phone: '67896789',
        contact_mobile: '67896789',
        hldr_is_drvr_ind: 1,
        model_id: '',
        tonnage: 2.0,
        br_pic:null,
        br_pic_path_id: '',
        br_pic_path: '',
      }
      const driverData = {
        nm_drvr_rel: '1',
        nm_drvr_title: 1,
        nm_drvr_lst_nm: 'A',
        nm_drvr_fst_nm: 'PENG',
        nm_drvr_dob: '1990-02-03',
        nm_drvr_id_type: 1,
        nm_drvr_id_no: 'A1234563',
        nm_drvr_occ_id: 9,
        nm_drvr_exp: '1',
        open: true
      }
      Object.keys(testData).some(key => {
        if (!this.formData[key]) {
          this.formData[key] = testData[key]
        }
      })
      if (this.formData.nm_drvr_list[0]) {
        Object.keys(driverData).some(key => {
          if (!this.formData.nm_drvr_list[0][key]) {
            this.formData.nm_drvr_list[0][key] = driverData[key]
          }
        })
      } else {
        this.formData.nm_drvr_list[0] = driverData
      }
      this.nm_drvr_list_file[0].open = true
      this.formDataLock += 1
      this.formData = this.formData
    },
    changeDriversFile(data) {
      const {url, index, urlKey} = data
      this.$set(
        this.nm_drvr_list_file[index],
        urlKey,
        url
      )
    },
    handlerDriverPolicyFile(data, result) {
      // 第一名記名司機的HKID文件覆蓋掉投保人文件
      // this.idTypeFile = Object.assign(
      //   this.idTypeFile,
      //   data
      // )
      // this.$set(this.documentForm, 'id_type_pic_path_id', data.id)
      // this.$set(this.documentForm, 'id_type_pic_path', data.name)
      this.$set(this.formData, 'id_type_pic', data)
      this.$set(this.formData, 'id_type_pic_path_id', data.id)
      this.$set(this.formData, 'id_type_pic_path', data.name)
    },
    changeDriversOpenStatus(index, status) {
      this.nm_drvr_list_file[index].open = status
    },
    getHousemaidFormData(data) {
      this.$refs['use-personal-data'].handleSendData()
      data.marketing_data = JSON.parse(JSON.stringify(this.personalData))
      // debugger
      if (this.saveEdit)
        this.network().saveEditOrder(data)
      else
        this.network().saveOrder(data)
    },
    hanlerSave() {
      this.saveEdit = true
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        16: 'student-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        22: 'pet-policy-form'
      }
      if (this.productId != 11) {
        this.$refs[productForm[this.productId]].getSaveSubmitForm()
        return
      }
      // $router.push('/quoting/payment')
      // 獲取表單組件數據
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].getSaveSubmitForm(key)
      })
      // if(this.formData.isUpdatePolicyData === 1) {
      //   this.$refs['policy-holder'].openConfirmDialog()
      // }
      // else {
      this.handlerConfirmEditChangeInfo()
      // }

    },
    handlerConfirmEditChangeInfo(result) {
      let params = JSON.parse(JSON.stringify(this.formData))
      const filterDriverList = params.nm_drvr_list.filter(item => item.open)
      params.nm_drvr_list = filterDriverList
      // params.nm_drvr_list.forEach((item,index)=>{
      //   item = Object.assign(item,this.nm_drvr_list_file[index])
      // })
      // 合并 document
      // params = Object.assign(params, this.documentForm)
      if (result) {
        params.upd_def_addr = 1 // 標記需要更新常置資料
      }
      params.less_verify_save = 1
      this.network().saveEditOrder(params)
    },

    handlerNext() {
      this.$refs['use-personal-data'].handleSendData()
      // this.$refs['drivers-base-info-form'].submitForm()
      // return
      this.saveEdit = false
      this.setCouponData(null)
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        16: 'student-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        22: 'pet-policy-form',
      }
      if (this.productId != 11) {
        this.$refs[productForm[this.productId]].submitForm()
        return
      }
      // $router.push('/quoting/payment')
      // 獲取表單組件數據
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {
        return
      }
      // 表單校驗
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          const {updDefInfo = []} = this.formData
          if(this.isFina)
          {
            this.handlerConfirmChangeInfo()
            return
          }
          if (updDefInfo && updDefInfo.length > 0&&!this.isFina) {
            // if(this.formData.isUpdatePolicyData === 1) {
            // this.$refs['policy-holder'].openConfirmDialog()
            this.$refs['confirm-information'].changeDialog()
          } else {
            this.handlerConfirmChangeInfo()
          }
        } else {
          this.scrollToValidDom(rules)
        }
      })

    },

    getData(personalData){
      this.personalData = personalData
    },
    handlerConfirmChangeInfo(result) {
      this.$refs['use-personal-data'].handleSendData()
      let params = JSON.parse(JSON.stringify(this.formData))
      const filterDriverList = params.nm_drvr_list.filter(item => item.open)
      params.nm_drvr_list = filterDriverList
      params.marketing_data = JSON.parse(JSON.stringify(this.personalData))
      // params.nm_drvr_list.forEach((item,index)=>{
      //   item = Object.assign(item,this.nm_drvr_list_file[index])
      // })
      // 合并 document
      // params = Object.assign(params, this.documentForm)
      if (result) {
        params.upd_def_addr = 1 // 標記需要更新常置資料
      }
      this.network().saveOrder(params)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    // file-container 組件刪除文件
    handlerDeleteFile(otherData) {
      const {type, index, idKey, nameKey, urlKey} = otherData
      if (type === 'other') {
        this.formData.other_file.splice(index, 1)
      }
      if (type === 'driver' || type === 'driverLicence') {
        [urlKey, nameKey, idKey].some(key => {
          this.$set(
            this.nm_drvr_list_file[index],
            key,
            ''
          )
        })
        // 刪除另外一個組件數據
        this.$refs['drivers-base-info-form'].updateDeleteDriversFileData({
          index,
          idKey,
          nameKey,
          urlKey
        })
        if (index == 0 && this.policyOneDriver && type === 'driver') {
          this.$set(this.formData, 'id_type_pic', null)
          this.$set(this.formData, 'id_type_pic_path_id', '')
          this.$set(this.formData, 'id_type_pic_path', '')
        }
      }
    },
    handlerUploadSuccess({data, result, otherData}) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      const {id = '', name = '', url = '', client_name = ''} = data
      if (type === 'other') {
        if (index !== '') {
          this.$set(this.formData.other_file, index, data)
          // this.documentForm.other_file[index] = data
        } else {
          if (!this.formData.other_file) {
            this.formData.other_file = []
          }
          this.formData.other_file.push(data)
        }
      }
      // else if(type=='driverLicence'){
      //   this.$set(this.nm_drvr_list_file[index], 'nm_drvr_licence_pic_path_id', id)
      //   this.$set(this.nm_drvr_list_file[index], 'nm_drvr_licence_pic_path', name)
      //   this.$set(this.nm_drvr_list_file[index], 'nm_drvr_licence_pic_url', url)
      //   this.$set(this.nm_drvr_list_file[index], 'nm_drvr_licence_client_name', client_name)
      // }
      else if (index === '') {
        if (target) {
          this.$set(this.formData, target, data)
          if (target == 'id_type_pic') {
            if (this.policyOneDriver) {
              this.$refs['drivers-base-info-form'].updateOnePolicyFile(data)
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_path_id', id)
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_path', name)
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_url', url)
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_client_name', client_name)
            }
          }
        }
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, name)
        this.$refs['form'].clearValidate([idKey])
      }
      // drivers
      else {
        // this.formData.nm_drvr_list[index][idKey] = id
        // this.formData.nm_drvr_list[index][nameKey] = name
        this.$refs['drivers-base-info-form'].updateDriversFileData({
          index,
          idKey,
          nameKey,
          ...data
        })
        this.$set(this.nm_drvr_list_file[index], nameKey, name)
        this.$set(this.nm_drvr_list_file[index], 'client_name', client_name)
        this.$set(this.nm_drvr_list_file[index], otherData.client_name, client_name)
        this.$set(
          this.nm_drvr_list_file[index],
          urlKey,
          url)
        if (index == 0 && this.policyOneDriver && type === 'driver') {
          this.$set(this.formData, 'id_type_pic', data)
          this.$set(this.formData, 'id_type_pic_path_id', id)
          this.$set(this.formData, 'id_type_pic_path', name)
        }
      }
    },
    handlerUploadDelete({otherData}) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData

      if (type === 'other') {
        if (index !== '') {
          this.$set(this.formData.other_file, index, null)
        }
      } else if (index === '') {
        if (target) {
          this.$set(this.formData, target, null)
          if (target == 'id_type_pic') {
            if (this.policyOneDriver) {
              this.$refs['drivers-base-info-form'].deleteOnePolicyFile()
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_path_id', '')
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_path', '')
              this.$set(this.nm_drvr_list_file[0], 'nm_drvr_id_type_pic_url', '')
              this.$set(this.nm_drvr_list_file[0], 'client_name', '')
            }
          }
        }
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$refs['form'].clearValidate([idKey])
      }
    },
    handler() {
      return {
        handlerBackFillData: data => {
          const {
            id_type_pic,
            licence_pic,
            ncd_proof,
            address_pic,
            rgtn_pic,
            other_file,
            br_pic
          } = data
          if (id_type_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                id_type_pic_path_id: id_type_pic.id,
                id_type_pic_path: id_type_pic.path
              }
            )
          }
          if (ncd_proof) {
            this.formData = Object.assign(
              this.formData,
              {
                ncd_proof_path_id: ncd_proof.id,
                ncd_proof_path: ncd_proof.path
              }
            )
          }
          if (rgtn_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                rgtn_pic_path_id: rgtn_pic.id,
                rgtn_pic_path: rgtn_pic.path
              }
            )
          }
          if (br_pic) {
            this.formData = Object.assign(
              this.formData,
              {
                br_pic_path_id: br_pic.id,
                br_pic_path: br_pic.path
              }
            )
          }
        },
        initDriversFile: (data = [], no_of_nm_drvr, class_id) => {
          const count = data.length || 1
          let number = 4
          if (class_id != 11) {
            number = 2
            this.nm_drvr_list_file.splice(number, 2)
          }
          for (let i = 0; i < number; i++) {
            let obj = this.nm_drvr_list_file[i]
            if (!data[i]) {
              data[i] = {}
            }
            let {nm_drvr_id_type_pic_url = '', nm_drvr_licence_pic_url = ''} = data[i]
            if (Number(no_of_nm_drvr) - 1 >= i) {
              this.nm_drvr_list_file[i] = Object.assign(obj, {
                open: true,
                nm_drvr_id_type_pic_url,
                nm_drvr_licence_pic_url
              })
            } else {
              this.nm_drvr_list_file[i] = Object.assign(obj, {
                open: false
              })
            }
          }
        }
      }
    },
    network() {
      return {
        getQuoteDetail: async () => {
          let {data} = await getQuoteDetail({
            order_id: this.orderId
          },this.productId)
          // 加個標記，組件監聽到變化才可以覆蓋組件裏的表單數據
          let params = {
            less_verify_save: 0,
            ...data
          }
          this.formData = JSON.parse(JSON.stringify(params))
          let {referrer_is_special,max_code_disc_prm} = data||{}
          if(this.isHzmb)
            this.formData.hldr_is_drvr_ind = 1
          this.max_code_disc_prm= max_code_disc_prm
          this.referrer_is_special= referrer_is_special
          let {pcy_cmnt_dt} = this.formData||{}
          if(!pcy_cmnt_dt)
            this.formData.pcy_cmnt_dt = dayjs().add(1,'day').format('YYYY-MM-DD')
          if(this.isFina&&this.cust_typ){
            this.formData.cust_typ = this.cust_typ
          }
          let {quote_coverage_list} = this.formData||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          this.handler().initDriversFile(data.nm_drvr_list, data.no_of_nm_drvr, data.class_id)
          if(this.productId==11){
            kyc_benefit.some(item=>{
              if(item.is_selected==1)
                this.formData.benefits.push(item.id)
            })
            this.formData.benefits= [...new Set( this.formData.benefits)]
            this.handler().handlerBackFillData(data)
            this.handlerExtraData()
          }
          // this.resultFormData = JSON.parse(JSON.stringify(this.formData))
          this.quote_coverage_list = this.formData.quote_coverage_list
          this.handlerSetCode(this.formData)
          this.amount = this.formData.amount
          this.formDataLock += 1
        },
        verifyPromoCode: async () => {
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.formData.customer_id,
              code: this.code
            })
            let params ={}
            params ={
              ...this.selectCode
            }
            params.is_campaign_code = data.is_campaign_code
            this.setSelectCode(params)
            if (data.code == 1000) {
              this.network().applyOrderCode()
            }
          } else {
            this.network().applyOrderCode()
          }

        },
        applyOrderCode: async () => {
          let {coupon = {}, code = {},is_campaign_code} = this.selectCode || {}
          let params = {}
          params.coupon = coupon.coupon_code
          params.code = code.code
          if(is_campaign_code)
          {
            params.campaign_code = coupon.coupon_code
            params.coupon = ''
          }
          params = {
            ...params,
            ...this.code_discount_info
          }
          const {dataCode} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.formData.customer_id,
            ...params,
            code_disc_prm:this.code_disc_prm
          })
          this.setReferrerData({
            ...this.code_discount_info
          })
          this.mixinNetwork().getOrderReferralList({code:params.code})
          this.formData = Object.assign(this.formData, dataCode)
          this.network().changeAmountData()
        },
        changeAmountData: async () => {
          let {data} = await getQuoteDetail({
            order_id: this.orderId
          },this.productId)
          this.quote_coverage_list = data.quote_coverage_list
          let {referrer_is_special,max_code_disc_prm} = data||{}
          this.max_code_disc_prm= max_code_disc_prm
          this.referrer_is_special= referrer_is_special
          this.amount = data.amount
          this.handlerSetCode(data, 'manual')
          if(this.formData.class_id==11 || this.formData.class_id==12 || this.formData.class_id==14)
            this.handlerExtra()
        },
        saveEditOrder: params => {
          const lastParams = {
            ...params,
            no_of_nm_drvr: params && params.nm_drvr_list ? params.nm_drvr_list.length : 0,
            order_id: this.orderId,
            customer_id: this.customerId,
            code: this.code, // 優惠碼
            less_verify_save: 1,
            ...this.code_discount_info,
          }
          let {coupon = {}, code = {},is_campaign_code} = this.selectCode || {}
          lastParams.coupon = coupon.coupon_code
          if(is_campaign_code){
            lastParams.campaign_code = coupon.coupon_code
            delete lastParams.coupon
          }
          saveOrder(lastParams).then(Data => {
            const {data} = Data
            if (data) {
              this.$message({
                type: 'warning',
                message: data.message
              })
              // 存儲投保資料，創建 refer 要用
              this.setQuoteInformationForm(lastParams)
              // 去 refer 頁面
              this.$router.push({
                path: '/quoting/quote/save',
                query: {
                  order_id: this.orderId,
                  customer_id: this.customerId,
                  quote_no: this.formData.quotation_number,
                  product_id: this.productId
                }
              })
            }
          }).catch(e => {
            const {code, message_language} = e.response.data
            // 对挡风玻璃险的错误提示进行弹窗显示
            if(code == 4533 || code == 4534){
              let options = {
                show: true,
                btnType: 'danger',
                message: message_language,
                tips: 'Click “OK” to remove the extra benefit'
              }
              Object.assign(this.$refs.msg, options)
            }
          })
        },
        saveOrder: async params => {
          let lastParams = {
            ...params,
            no_of_nm_drvr: params.nm_drvr_list ? params.nm_drvr_list.length : 0,
            order_id: this.orderId,
            customer_id: this.customerId,
            code: this.code, // 優惠碼
            less_verify_save: 0,
            ...this.code_discount_info,
          }
          let {coupon = {}, code = {},is_campaign_code} = this.selectCode || {}
          lastParams.coupon = coupon.coupon_code
          if(is_campaign_code){
            lastParams.campaign_code = coupon.coupon_code
            delete lastParams.coupon
          }
          // debugger
          const {data} = await saveOrder(lastParams)
          if (data.code && [4178, 4179].includes(data.code)) {
            this.$message({
              type: 'warning',
              message: data.message_language
            })
            // 存儲投保資料，創建 refer 要用
            this.setQuoteInformationForm(lastParams)
            this.setQuoteForm(lastParams)

            if (this.isReferralRequest) {
              this.$emit('refer')
              return
            }
            if(this.productId==22){
              // this.$ConfirmBox({
              //   isNewConfirm:true,
              //   width:500,
              //   confirmBtn:'Done',
              //   message: 'We cannot find any plans that match with your request at the moment. Thank you for supporting HoldCover!',
              // }).then(() => {
              // })
            }
            else {
              // 去 refer 頁面
              this.$router.push({
                path: '/quoting/refer/info',
                query: {
                  order_id: this.orderId,
                  product_id: this.productId
                }
              })
            }
          } else {
            if (this.isReferralRequest) {
              this.$emit('success')
              return
            }
            let path = this.isFina?'/quoting/referrer/send/payment':'/quoting/payment/success'
            this.$router.push({
              path: path,
              query: {
                order_id: this.orderId,
                product_id: this.productId,
                customer_id: this.customerId,
                quote_no: this.formData.quotation_number,
              }
            })
          }
        },
        getExtraCompute: async params => {
          const {data} = await getExtraCompute(params)
          let {sidebar_premium,benefit_coverage} = data
          this.quote_coverage_list.sidebar_premium = sidebar_premium
          let amountArr =  sidebar_premium.filter(item=>item.name=='paid')
          if(amountArr){
            this.amount = amountArr[0].premium
          }
          this.formData.benefit_coverage = benefit_coverage
        },

        getAccountDetail: async () => {
          if(!this.customerId)return
          const {data} = await getAccountDetail({
            customer_id: this.customerId
          })
          let formData = JSON.parse(JSON.stringify(this.formData))
          const {customer_profile} = data||{}
          let {verified} = customer_profile||{}
          if(this.isCopy){
            this.formData ={}
            let form = {
              isrd_lst_nm: '',
              isrd_fst_nm: '',
              isrd_title: '',
              isrd_dob: '',
              id_type: '',
              id_no: '',
              pp_no: '',
              mobile_no: '',
              email: '',
              occ_id: '',
              isrd_com_nm: '',
              phone_no: '',
              bsns_nature_id: '',
              contact_nm: '',
              id_type_pic:{},
              // contact_occ_id: '',
              // contact_mobile: '',
              contact_phone: '',
              // contact_email: '',
              addr_room: '',
              addr_floor: '',
              addr_block: '',
              addr_building: '',
              addr_street: '',
              addr_district: '',
              addr_area: '',
              addr_region: '',
            }
            if(verified!=20) return
            Object.keys(form).some((key)=>{
              formData[key] = customer_profile[key]
              if(key=='mobile_no'){
                formData.mobile_no = customer_profile.phone
              }
            })
            this.formData  = formData
            this.formDataLock += 1
          }

          // const {pre_fill_referrer_code, referrer_nm, referrer_user_id} = customer_profile
          // this.pre_fill_referrer_code = pre_fill_referrer_code
          // if(pre_fill_referrer_code){
          //   let params = {}
          //   params.code = {
          //     selectCode: 2,
          //     code: pre_fill_referrer_code,
          //     referrer: referrer_nm,
          //     referrer_user_id
          //   }
          //   this.setSelectCode(params)
          // }
        },
      }
    },

    clearExtraOptions(){
      this.formData.extra_benefits.splice(this.formData.extra_benefits.indexOf(2),1)
    },
    getElement(){
      this.container = this.$refs['container'].parentElement
    },
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  padding: 15px;
  .extra_checkbox{
    ::v-deep .el-checkbox-group{
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .main-container {
    .eff-box {
      width: calc(50% - 10px);
    }

    .document-wrapper {
      .flex {
        max-width: 393px;
        .form-item {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
        .v-upload-container{
          min-width: 393px;
        }
      }

      .drivers-file-container {
        position: relative;
        display: flex;
        flex-wrap: wrap;

        .card {
          position: relative;
          margin-bottom: 15px;
          width: calc(50% - 10px);

          &:nth-child(2n-1) {
            margin-right: 10px;
          }

          &:nth-child(2n) {
            margin-left: 10px;
          }

          .mask {
            z-index: 2;
            position: absolute;
            top: 40px;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(255, 255, 255, 0.7);
          }
        }
      }
    }
  }

  .right {
    margin-left: 15px;
    min-width: 250px;
    max-width: 250px;

    .company-logo {
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // width: 78px;
      height: 42px;

      img {
        // width: 100%;
        // max-height: 100%;
        height: 42px;
      }
    }

    .label {
      display: block;
      margin: 10px 0;
      font-size: 16px;
      line-height: 19px;
      font-weight: bold;
    }

    .total-box {
      margin: 15px -15px -15px -15px;
      padding: 15px;
      background: #ecf5ff;

      span {
        display: block;
        color: #616266;
        font-size: 14px;
      }

      .amount {
        font-size: 24px;
        color: #409eff;
        font-weight: bold;
      }
    }
  }
  .margin-top-ten{
    margin-top: 10px;
  }
  .plan-info-container{
    width: 280px;
  }
  .flex-algin{
    //align-items: center;
    margin-bottom: 10px;
    .label{
      margin-top: 0;
    }
    .icon{
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
  }

}
</style>
